'use client'

import { Image } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useAsset } from '@marketplace-web/shared/assets'

const AccesibilitySecondSection = () => {
  const translate = useTranslate('accessibility.second-section')
  const asset = useAsset('/assets/landing-pages/accessibility')

  const cardsData = [
    {
      title: translate('cards.card1.title'),
      description: translate('cards.card1.description'),
      image: asset('card-1.svg'),
    },
    {
      title: translate('cards.card2.title'),
      description: translate('cards.card2.description'),
      image: asset('card-2.svg'),
    },

    {
      title: translate('cards.card3.title'),
      description: translate('cards.card3.description'),
      image: asset('card-3.svg'),
    },
  ]

  return (
    <section className="accessibility-landingpage__second-section">
      <h2 className="accessibility-landingpage__second-section-title">{translate('title')}</h2>
      <div className="accessibility-landingpage__second-section-cards">
        {cardsData.map(card => (
          <div className="accessibility-landingpage__second-section-card" key={card.title}>
            <div className="accessibility-landingpage__second-section-card-image">
              <Image src={card.image} alt={card.title} />
            </div>
            <div className="accessibility-landingpage__second-section-card-text">
              <h3 className="accessibility-landingpage__second-section-card-title">{card.title}</h3>
              <div className="accessibility-landingpage__second-section-card-description">
                {card.description}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default AccesibilitySecondSection
